import { cdnImage } from '../hero/interviewers';

/**
 * FeatureStack 스크린 캡처 — 어드민 static-images CDN
 * section-01 → 면접관 선택, section-02-2 → 나를 위한 질문,
 * section-03 → 면접 완벽 재현, section-04 → 면접 후 피드백
 */
export const FEATURE_SCREEN_SRC = {
  interviewerPick: cdnImage('2d2967d0-3acb-4576-8e6e-90cbf342accb.png'),
  questions: cdnImage('6262a8c3-2646-4d84-8825-034f32f51a19.png'),
  interview: cdnImage('8a2fa5ec-d124-4670-99ed-9c6e177f58f8.png'),
  report: cdnImage('b9bb0804-928f-42bf-9a69-05a34536464a.png'),
} as const;
